module.exports = __webpack_public_path__ + "img/1x2gaming.2f7bbd47.svg";